import { render } from "./SortOrderDropDown.vue?vue&type=template&id=195be6a5&ts=true"
import script from "./SortOrderDropDown.vue?vue&type=script&lang=ts"
export * from "./SortOrderDropDown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__